import { render, staticRenderFns } from "./ControlButtons.vue?vue&type=template&id=2ef1a313&scoped=true&lang=pug&"
import script from "./ControlButtons.vue?vue&type=script&lang=js&"
export * from "./ControlButtons.vue?vue&type=script&lang=js&"
import style0 from "./ControlButtons.vue?vue&type=style&index=0&id=2ef1a313&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ef1a313",
  null
  
)

export default component.exports